<template>
    <div component="Client" template="page">
        <div class="bg">
            <v-card class="holder">
                <client-header @onLoad="onLoad" />
                <client-projects :loading="loading" />

                <popup
                    :name="'newProject'"
                    :visible="getIsNewProjectPopup"
                    @close="closeNewProjectPopup"
                    :isModal="true"
                >
                    <project-create />
                </popup>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ProjectCreate from '@/components/Project/Create/ProjectCreate';
import ClientHeader from '@/components/Client/ClientHeader';
import ClientProjects from '@/components/Client/ClientProjects';

export default {
    name: 'Client',

    components: {
        ClientProjects,
        ClientHeader,
        ProjectCreate,
    },

    data() {
        return {
            loading: true,
            showProject: false,
        };
    },

    mounted() {
        this.loading = false;
    },

    methods: {
        ...mapMutations(['setIsNewProjectPopup']),

        onLoad(val) {
            this.loading = val;
        },

        closeNewProjectPopup() {
            this.setIsNewProjectPopup(false);
        },
    },

    computed: {
        ...mapGetters(['getIsNewProjectPopup']),

        showChild: {
            get: function () {
                return this.showProject;
            },
            set: function (newVal) {
                this.showProject = newVal;
            },
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Client'] {
    height: 100vh;
    max-height: 100vh;

    .holder {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        padding: 20px 20px 10px;
        .radiusBig !important;
    }
}
</style>
